import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

// Firebase
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';

// RxJS
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

// Models
import { User } from './user.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  user$: Observable<User>;

  constructor(
    private afa: AngularFireAuth,
    private afs: AngularFirestore,
    private router: Router,
  ) {
    this.user$ = this.afa.authState.pipe(
      switchMap(user => {
        if(user) {
          return this.afs.doc<User>(`users/${user.uid}`).valueChanges();
        } else {
          return of(null);
        }
      })
    )
  }

    async signin(mail, pass, returnUrl) {
        try {
            const credential = await this.afa.signInWithEmailAndPassword(mail, pass);
            this.updateUserData(credential.user);
            this.user$.subscribe(user => {
                if(returnUrl) {
                    return this.router.navigateByUrl(returnUrl);
                } else {
                    if(user.admin) {
                        return this.router.navigate(['/admin']);
                    } else {
                        return this.router.navigate(['/dashboard']);
                    }
                }
            })
        } catch (e) {
            return e;
        }
    }

    async signup(mail, pass, data) {
        const credential = await this.afa.createUserWithEmailAndPassword(mail, pass);
        this.createUserData({
            uid: credential.user.uid,
            email: credential.user.email,
            name: data.name,
            phone: data.phone,
            zipcity: data.zipcity,
            streetnumber: data.streetnumber,
            cid: data.cid,
        })
        return this.router.navigate(['/dashboard']);
    }

    async signout() {
        await this.afa.signOut();
        return this.router.navigate(['']);
    }

  async reset(mail) {
    const response = await this.afa.sendPasswordResetEmail(mail);
    return this.router.navigate(['']);
  }

  private updateUserData(user) {
    const userRef: AngularFirestoreDocument<User> = this.afs.doc(`users/${user.uid}`);

    const data: any = {
      uid: user.uid,
      mail: user.email,
    }
    
    return userRef.set(data, { merge: true });
  }

    private createUserData(user) {
        const userRef: AngularFirestoreDocument<User> = this.afs.doc(`users/${user.uid}`);
        const data: User = {
            uid: user.uid,
            mail: user.email,
            name: user.name,
            phone: user.phone,
            zipcity: user.zipcity,
            streetnumber: user.streetnumber,
            cid: user.cid
        }
        return userRef.set(data, { merge: true });
    }

}
